import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type PasswordRequirement = {
  description: string;
  isSatisfied: boolean;
  id: string;
};

export function usePasswordRequirements(password: string): PasswordRequirement[] {
  const { t } = useTranslation();

  const validations = useMemo(
    () => [
      {
        description: t('passwordRequirements.length'),
        isSatisfied: password.length >= 8,
        id: 'length',
      },
      {
        description: t('passwordRequirements.uppercase'),
        isSatisfied: /[A-Z]/.test(password),
        id: 'uppercase',
      },
      {
        description: t('passwordRequirements.lowercase'),
        isSatisfied: /[a-z]/.test(password),
        id: 'lowercase',
      },
      {
        description: t('passwordRequirements.digits'),
        isSatisfied: /[0-9]/.test(password),
        id: 'digits',
      },
      {
        description: t('passwordRequirements.specialCharacters'),
        isSatisfied: /[^a-zA-Z0-9]/.test(password),
        id: 'special-characters',
      },
    ],
    [password, t]
  );
  return validations;
}
